(function(){
    'use strict'; 
    angular.module('app').controller('UpdateJobModalController', UpdateJobModalController);
    UpdateJobModalController.$inject = [
        '$uibModalInstance',
        'FleetService',
        'toastr',
        '$q',
        'TypeStatusConsts',
        'selectedJobs'
    ];

    function UpdateJobModalController(
        $uibModalInstance,
        FleetService,
        toastr,
        $q,
        TypeStatusConsts,
        selectedJobs
    ){
        const vm = this;
        const { jobStatuses, jobStatusesValue } = TypeStatusConsts;
        vm.status = [{
                    value: jobStatusesValue.unassigned,
                    viewName: jobStatuses[jobStatusesValue.unassigned.toLowerCase()]
                }, {
                    value: jobStatusesValue.forapproval,
                    viewName: jobStatuses[jobStatusesValue.forapproval.toLowerCase()]
                }, {
                    value: jobStatusesValue.pending,
                    viewName: jobStatuses[jobStatusesValue.pending.toLowerCase()]
                }, {
                    value: jobStatusesValue.accepted,
                    viewName: jobStatuses[jobStatusesValue.accepted.toLowerCase()]
                }, {
                    value: jobStatusesValue.received,
                    viewName: jobStatuses[jobStatusesValue.received.toLowerCase()]
                }, {
                    value: jobStatusesValue.inprogress,
                    viewName: jobStatuses[jobStatusesValue.inprogress.toLowerCase()]
                }, {
                    value: jobStatusesValue.delivered,
                    viewName: jobStatuses[jobStatusesValue.delivered.toLowerCase()]
                }, {
                    value: jobStatusesValue.failed,
                    viewName: jobStatuses[jobStatusesValue.failed.toLowerCase()]
                }, {
                    value: jobStatusesValue.notyetstarted,
                    viewName: jobStatuses[jobStatusesValue.notyetstarted.toLowerCase()]
                }]

        
        vm.updateJobs = updateJobs;
        vm.closeModal = closeModal;
 
        init();
        function init(){ 
           
        }

        function updateJobs(){
            vm.loading = true;
            // const jobs = selectedJobs.filter(job => {
            //     return job.jobStatus == 'forapproval' || job.jobStatus == 'unassigned';
            // });
            const jobIds = selectedJobs.map(job=>{ return job.id; });

            if(jobIds.length !== 0) {
                FleetService.Jobs.updateStatus(jobIds,
                    { toStatus: vm.selectedJobsStatus.value },
                    () => {
                       vm.loading = false;
                        toastr.success( "Job status has been updated.", "Success",);
                        $uibModalInstance.close('reloadTable');
                    },
                    error => {
                        vm.loading = false;
                        console.log(error);
                        toastr.error("Error", error.message)
                        $uibModalInstance.close('reloadTable');
                    });
                return; 
            }
            
        }
        
        function closeModal() {
            $uibModalInstance.dismiss();
        }
    }
})();



// WEBPACK FOOTER //
// ./js/controllers/jobs/updateJobModalController.js